














































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class wdOrder extends Vue {
  timeValue = [];
  /**登陆信息 */
  public userInfo =
    localStorage.getItem("dayChecked") == "true"
      ? JSON.parse(localStorage.getItem("userInfo"))
      : JSON.parse(sessionStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    start: dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD") + " 00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " 23:59:59",
    skip: 0,
    count: 10,
    memberKey:"",
    deliveryType:null,
    deliveryState:null,
  };
  deliveryStatusOptions = [
        {
            label:'未提货',
            value:1,
        },
        {
            label:'部分提货',
            value:2,
        },
        {
            label:'已提货',
            value:3,
        },
    ]
    deliveryOptions = [
        {
            label:'自提',
            value:2,
        },
        {
            label:'快递',
            value:1,
        },
    ]
  /**列表选项 */
  selectTable = [];
  exloading = false;
  // 合计
  totalNum=0;
  totalPrice=0;
  totalUnSelfPickupNum=0;
  /**导出订单明细 */
  exDeloading = false;
  exPopDeloading = false;
  /**销售订单明细 */
  dialogVisible = false;
  form:any={};
  fmoney = fmoney;

  /**支付方式 */
    get payName(){
        let str = "";
        if(this.form.paymentMethod){
            switch (this.form.paymentMethod) {
                case 1:
                    str="会员卡"
                    break;
                case 2:
                    str="现金"
                    break;
                case 3:
                    str="微信"
                    break;
                case 4:
                    str="支付宝"
                    break;
                case 5:
                    str="现金+会员卡+微信"
                    break;
                case 6:
                    str="现金+会员卡+支付宝"
                    break;
                case 7:
                    str="现金+微信"
                    break;
                case 8:
                    str="现金+支付宝"
                    break;
                case 9:
                    str="会员卡+微信"
                    break;
                case 10:
                    str="会员卡+支付宝"
                    break;
                case 11:
                    str="现金+会员卡"
                    break;
                    case 13:
                    str="线下微信"
                    break;
                case 14:
                    str="线下支付宝"
                    break;
                case 15:
                    str="现金+线下支付宝"
                    break;
                case 16:
                    str="会员卡+线下支付宝"
                    break;
                case 17:
                    str="现金+线下微信"
                    break;
                case 18:
                    str="会员卡+线下微信"
                    break;
                case 19:
                    str="线下微信+线下支付宝"
                    break;
                case 20:
                    str="现金+会员卡+线下支付宝"
                    break;
                case 21:
                    str="现金+会员卡+线下微信"
                    break;
                case 22:
                    str="现金+线下支付宝+线下微信"
                    break;
                case 23:
                    str="会员卡+线下支付宝+线下微信"
                    break;
            
                default:
                    break;
            }
        }
        return str;
    }
    get orderStatus(){
        let str = "";
        switch (this.form.orderStatus) {
            case 1:
                str="待支付"
                break;
            case 2:
                str="支付成功"
                break;
            case 3:
                str="支付失败"
                break;
            case 4:
                str="已关闭"
                break;
        
            default:
                break;
        }
        return str;
    }

  async mounted() {
    this.timeValue = [
      dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
      dayjs(new Date()).format("YYYY-MM-DD"),
    ];
    await this.getlist();
  }
  activated() {}


  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetOnlineOrderListToPos(this.searchValue);
    this.listData = result.items.map((v) => {
      return {
        ...v,
      };
    });
    this.total = result.totalCount;
    this.totalNum = result.totalNum;
    this.totalPrice = result.totalPrice;
    this.totalUnSelfPickupNum = result.totalUnSelfPickupNum;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = "合计";
    sums[3] = this.totalNum;
    sums[4] = this.totalPrice;
    sums[7] = this.totalUnSelfPickupNum;
    return sums;
  }
  getDetailSummaries(param) {
    const { columns, data } = param;
    console.log('param',param);
    let returnNum = data.length>0?data.map(v=>calculate.subtraction(v.num,v.selfPickupNum)).reduce((a,b)=>calculate.addition(a,b)):0;
    const sums = [];
    sums[0] = "合计";
    sums[3] = this.form.num;
    sums[4] = fmoney(this.form.goodsPrice);
    sums[5] = fmoney(this.form.actualPayment);
    sums[6] = returnNum;
    return sums;
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [
        dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
        dayjs(new Date()).format("YYYY-MM-DD")
    ];
    this.searchValue = {
        shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
        start: dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD") + " 00:00:00",
        end: dayjs(new Date()).format("YYYY-MM-DD") + " 23:59:59",
        skip: 0,
        count: 10,
        memberKey:"",
        deliveryType:null,
        deliveryState:null,
    };
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }

  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.start = val[0] + " 00:00:00";
      this.searchValue.end = val[1] + " 23:59:59";
    } else {
      this.searchValue.start = "";
      this.searchValue.end = "";
    }
  }

  export_table(item) {
    try {
      this.exloading = true;
      Public.GetOnlineOrderListToPosReport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        var fileName = "网店订单报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
  exportDetailAll(item) {
    try {
      this.exDeloading = true;
      Public.GetOnlineOrderItemListToPosReport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        var fileName = "网店订单明细报表";
        fileDownload(res.data, fileName + ".xls");
        this.exDeloading = false;
      });
    } catch (error) {
      this.exDeloading = false;
    }
  }
  exportSingleDetail(){
    try {
      this.exPopDeloading = true;
      Public.GetOnlineOrderItemListToPosByIdReport(
        {
          shopId:this.searchValue.shopId,
          id:this.form.id,
        }
      ).then((res) => {
        var fileName = "网店订单明细报表";
        fileDownload(res.data, fileName + ".xls");
        this.exPopDeloading = false;
      });
    } catch (error) {
      this.exPopDeloading = false;
    }
  }
  //提货状态
  getdeliveryStatusOptions(val){
    let str = ""
    str = this.deliveryStatusOptions.findIndex(v=>v.value==val)>-1?this.deliveryStatusOptions.find(v=>v.value==val).label:'';
    return str;
  }
  //配送状态
  getdeliveryOptions(val){
    let str = ""
    str = this.deliveryOptions.findIndex(v=>v.value==val)>-1?this.deliveryOptions.find(v=>v.value==val).label:'';
    return str;
  }
  closePop(){
      this.dialogVisible = false;
  }
  /**点击行 */
  async rowClick(row){
      await this.getDetail(row.id)
      this.dialogVisible = true;
  }
  /**订单详情 */
  async getDetail(id){
    let res = await Public.GetOnlineOrderById({id:id});
    this.form = {};
    this.form = res;
  }
  formatPrice(row, column, cellValue, index){
      let str = "";
      str = fmoney(cellValue);
      return str;
  }
   /**计算未提货数 */
    getUnThNum(item){
        let val = 0;
        val = calculate.subtraction(item.num,item.selfPickupNum);
        return val;
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/wdOrder/index.vue